import { CITY_IMAGE_PLACEHOLDER } from '../constants';

/**
 * Admin uploads are absolute Cloudinary URLs; seeded cities point at files in
 * `client/public`. Both work as an `src` as-is, so only a missing image needs
 * handling.
 */
export function resolveCityImage(imageUrl?: string | null): string {
  return imageUrl?.trim() || CITY_IMAGE_PLACEHOLDER;
}
